import styled from 'styled-components';
import { NO_ACTIVE_COLOR } from '../../../constants/css';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.css';

export const StyledSimpleBar = styled(SimpleBar)`
    .simplebar-scrollbar::before {
        background-color: ${NO_ACTIVE_COLOR} !important;
    }
`